export function profileColor(fio: string) {
    let rgb = [0, 0, 0];
    for (let i = 0; i < fio.length; i++)
        rgb[i % 3] = (rgb[i % 3] + fio[i].charCodeAt(0)) % 200
    return `rgb(${rgb[0]}, ${rgb[1]}, ${rgb[2]})`
}
export function profileAbb(fio: string) {
    let abbArr = fio.split(' ');
    let abb = ''
    for (let i = 0; i < Math.min(2, abbArr.length); i++)
        abb += abbArr[i].toUpperCase()[0] /*+ (i === 1 ? '' : '.')*/;
    return abb
}